<template>
    <v-container class="c-notices app-bg">
        <p v-html="insureNotice"></p>
        <div style="width: 140px;margin: 0 auto">
            <v-btn :disabled="disabled" class="card-btn" color="primary" style="margin: 0 auto" large @click="toUrl()">立即投保</v-btn>
        </div>
    </v-container>
</template>

<script>
    import notice from '@/assets/js/noticeNew'
    export default {
        data(){
            return {
                insureNotice: notice,
                url: "",
                disabled: true,
            }
        },
        mounted() {
            let productId = this.$route.params.productId;
            this.$axios.post("/app/api/product/getProductDetail", {productId: productId}).then(response => {
                this.url = response.data.productDetailBo.toUrl;
                this.disabled= false;
            })
        },
        methods: {
            toUrl(){
                location.href = this.url;
            }
        }
    }
</script>

<style scoped>

</style>